import React from "react";
import { Modal, StyleSheet, Text, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";


export default function VehicleInfo({
    modalVisible,
    setModalVisible,
    plate,
    brand,
    model,
    color
}) {
    return (
        <Modal
            animationType="fade"
            transparent={true}
            style={{ backgroundColor: "#000" }}
            visible={modalVisible}
            onRequestClose={() => setModalVisible(!modalVisible)}
        >
            <View style={styles.centeredView}>
                <View style={styles.modalView}>
                    <Icon
                        name="close"
                        size={32}
                        onPress={() => {
                            setModalVisible(!modalVisible);
                        }}
                        style={styles.closeButton}
                    />
                    <View style={styles.titleView}>
                        <Text style={styles.titleText}>{"Informações"}</Text>
                    </View>
                    <View style={{ alignItems: "flex-start", width: "100%" }}>
                        <Text style={styles.titleInfo}>{"Placa"}</Text>
                        <Text style={styles.dataInfo}>{plate}</Text>
                    </View>
                    <View style={{ flexDirection: "row", alignItems: "flex-start", width: "100%" }}>
                        <View>
                            <Icon name="information-outline" size={24} style={{ margin: 8 }} />
                        </View>
                        <View>
                            <View>
                                <Text style={styles.titleInfo}>{"Marca"}</Text>
                                <Text style={styles.dataInfo} >{brand}</Text>
                            </View>
                            <View>
                                <Text style={styles.titleInfo}>{"Modelo"}</Text>
                                <Text style={styles.dataInfo} >{model}</Text>
                            </View>
                            <View>
                                <Text style={styles.titleInfo}>{"Cor"}</Text>
                                <Text style={styles.dataInfo} >{color}</Text>
                            </View>
                        </View>
                    </View>
                </View>
            </View>
        </Modal >
    );
}

const styles = StyleSheet.create({
    centeredView: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0,0,0,0.5)",
    },
    titleView: {
        alignItems: "center",
    },
    titleText: {
        textAlign: "center",
        fontSize: Fonts.FONT_SIZE_20,
        fontWeight: "bold",
    },
    modalView: {
        margin: 20,
        backgroundColor: Colors.WHITE,
        borderRadius: 8,
        padding: 16,
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: {
            width: 0,
            height: 2,
        },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 5,
        width: "70%"
    },
    closeButton: {
        marginLeft: "auto",
        color: Colors.GRAY_DARK,
    },
    titleInfo: {
        fontSize: Fonts.FONT_SIZE_16,
        color: Colors.GRAY_DARK,

    },
    dataInfo: {
        fontSize: Fonts.FONT_SIZE_18,
        color: Colors.SECONDARY,
        fontWeight: "500",
    },
});
